var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.987 26.894C23.2983 25.2549 23.3369 23.4767 23.3005 22.7348C23.7374 22.8395 24.6765 22.986 24.9386 22.7348C25.2662 22.4208 25.5934 20.9656 26.2487 20.3376C26.9327 19.6819 26.9043 18.9668 26.9043 17.0827C26.9043 15.5755 25.2652 16.7315 24.9386 17.0827C26.2487 10.503 24.6096 5.91316 21.0035 2.96278C17.0697 0.340565 12.2926 -0.753027 6.26453 3.26624C0.236422 7.28551 1.56872 13.9424 2.98838 16.7685C2.55159 16.5592 1.54695 16.2035 1.02277 16.4547C0.36754 16.7687 0.803788 18.9046 1.0592 19.3942C1.38681 20.0222 2.33323 21.4788 2.66084 22.4208C2.92293 23.1744 4.29891 22.9442 4.95414 22.7348C4.94955 23.9204 5.20263 26.412 6.25165 26.894",
    stroke: "#202E5F",
    strokeWidth: 0.65564,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20117 26.8408C13.4628 28.8077 18.7079 26.8408 18.7079 26.8408",
    stroke: "#202E5F",
    strokeWidth: 0.65564,
    strokeDasharray: "1.31 1.31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackHead);
export default __webpack_public_path__ + "static/media/BackHead.882b9d90674fd390507c35bab84a6bd4.svg";
export { ForwardRef as ReactComponent };